"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.i18n = void 0;
const i18next_1 = __importDefault(require("i18next"));
const generatedI18NextInterface_1 = require("../generated/generatedI18NextInterface");
function tracePropAccess(obj, path = '') {
  return new Proxy(obj, {
    get(target, propKey, receiver) {
      const tmp = Reflect.get(target, propKey, receiver);
      if (tmp && typeof tmp === 'object') {
        return tracePropAccess(tmp, `${path}${propKey}.`);
      } else if (typeof tmp === 'string') {
        return i18next_1.default.t(`${path}${propKey}`);
      } else if (typeof tmp === 'function') {
        return function (...args) {
          return i18next_1.default.t(`${path}${propKey}`, ...args);
        };
      } else {
        throw new Error(`Undefined type - ${typeof tmp} (${path}${propKey})`);
      }
    },
    set() {
      throw new Error('Permissions denied');
    }
  });
}
exports.i18n = tracePropAccess(generatedI18NextInterface_1.baseI18Object);